import React, { useState } from "react";
import { Link } from "react-router-dom";
import styles from "./LandingHeader.module.css";
import logoLight from "../../../../assets/logos/Logo_Gold_black.png";
import logoDark from "../../../../assets/logos/Logo_Gold.png";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faBars, faGift, faX } from "@fortawesome/free-solid-svg-icons";
import { useTheme } from "../../../../context/themeContext";
import { useAuth } from "../../../../context/authContext";
import ThemeToggle from "../../../utils/components/ThemeToggle/ThemeToggle";
import ProfileOptions from "../../../utils/components/header/components/ProfileOptions";
import { useBonuses } from "../../../../context/bonusContext";
import BonusCelebrationModal from "../../../../components/bonus/BonusCelebrationModal";

const LandingHeader = () => {
  const [menuOpen, setMenuOpen] = useState(false);
  const { theme } = useTheme();
  const { isAuthenticated } = useAuth();
  const { availableCount: bonusCount } = useBonuses();
  const logo = theme === "dark" ? logoDark : logoLight;

  const navItems = [
    { label: "Inicio", to: "/welcome" },
    { label: "Resultados", to: "/resultados" },
    { label: "Promociones", to: "/promociones" },
    { label: "Descarga", href: "#descarga" },
    ...(!isAuthenticated ? [{ label: "Regístrate", to: "/auth" }] : []),
    // En escritorio angosto no cabe: solo desde 1024px (siempre en el menú móvil).
    { label: "Blog", to: "/blog", wideOnly: true },
    { label: "Ayuda", to: "/ayuda" },
    { label: "Jugar", to: "/apuestas" },
  ];

  return (
    <header className={styles.header}>
      <div className={styles.container}>
        <Link to="/welcome" className={styles.logoLink}>
          <img src={logo} alt="Gold Loterías" className={styles.logo} />
        </Link>

        <div className={styles.rightSide}>
          <nav className={styles.nav} aria-label="Principal">
            {navItems.map((item) =>
              item.to ? (
                <Link
                  key={item.label}
                  to={item.to}
                  className={`${styles.navLink} ${item.wideOnly ? styles.navLinkWide : ""}`}
                >
                  {item.label}
                </Link>
              ) : (
                <a key={item.label} href={item.href} className={styles.navLink}>
                  {item.label}
                </a>
              )
            )}
          </nav>

          <ThemeToggle inline landing />

          {isAuthenticated && bonusCount > 0 && (
            <Link
              to="/perfil"
              state={{ section: "bonos" }}
              className="header__bonus-badge"
              aria-label={`Tienes ${bonusCount} ${bonusCount === 1 ? "bono disponible" : "bonos disponibles"}. Ver Mis bonos`}
              title="Mis bonos"
            >
              <FontAwesomeIcon icon={faGift} aria-hidden="true" />
              <span className="header__bonus-count">{bonusCount}</span>
            </Link>
          )}

          {isAuthenticated ? (
            <div className={styles.profileSlot}>
              <ProfileOptions />
            </div>
          ) : null}

          <button
            type="button"
            className={styles.hamburger}
            onClick={() => setMenuOpen(!menuOpen)}
            aria-label={menuOpen ? "Cerrar menú" : "Abrir menú"}
            aria-expanded={menuOpen}
          >
            <FontAwesomeIcon icon={menuOpen ? faX : faBars} />
          </button>
        </div>
      </div>

      {menuOpen && (
        <nav className={styles.mobileNav} aria-label="Móvil">
          {navItems.map((item) =>
            item.to ? (
              <Link
                key={item.label}
                to={item.to}
                className={styles.mobileNavLink}
                onClick={() => setMenuOpen(false)}
              >
                {item.label}
              </Link>
            ) : (
              <a
                key={item.label}
                href={item.href}
                className={styles.mobileNavLink}
                onClick={() => setMenuOpen(false)}
              >
                {item.label}
              </a>
            )
          )}
        </nav>
      )}
      {/* Celebración del bono de bienvenida si la recarga se confirma desde la landing */}
      <BonusCelebrationModal />
    </header>
  );
};

export default LandingHeader;
